export const languages = {
  en: {
    // App.js
    aboutTab: 'About',
    scanTab: 'Scan Card',
    fileTab: 'Open file',
    photoTab: 'Use your camera',
    searchTab: 'Search Record',
    dataTab: 'Card Details',

    // About.js
    aboutTitle: 'SMART Health Card Viewer',
    aboutSubtitle: 'View SMART Health Cards',
    getStarted: 'Get Started',
    scanDescriptionShort: 'Use a 2D barcode scanner',
    photoDescriptionShort: 'Start scanning using your camera',
    fileDescriptionShort: 'Upload a file containing a SMART Health Card',

    aboutContent1: 'Developed and maintained by',
    aboutContent2: 'The Commons Project',
    aboutContent3: 'this',
    aboutContent4: 'open source application',
    aboutContent5: 'can be used standalone or embedded within an EHR to read information in',
    aboutContent6: 'SMART Health Cards and Links',
    aboutContent7: 'Supported data types currently include',
    aboutContent8: 'COVID-19 vaccine cards',
    aboutContent9: 'general immunization records',
    aboutContent10: 'International Patient Summaries',
    aboutContent11: 'and Digital Health Insurance Cards',

    aboutContributing: 'If you would like to host the viewer yourself, contribute features or fixes to the project, or have any other questions, please contact',
    aboutPrivacy: 'Personal health information is processed exclusively in the browser and is never sent to the servers hosting the viewer',

    // Photo.js
    captureTitle: 'Capture SMART Health Card QR Code image',
    scanDescription: 'Please place the QR code in the frame. For best results, keep it steady and in good lighting.',
    cameraPaused: 'Camera paused',
    restartCamera: 'Restart Camera',
    changeCamera: 'Change Camera',
    openCamera: 'Open Camera',
    cameraAccessDenied: 'Camera access denied. Please allow camera access and try again.',
    noQrCode: 'No QR code detected. Please try again.',
    invalidQrCode: 'Invalid QR code format. Please scan a valid health card QR code.',
    qrCodeError: 'Error processing QR code. Please try again.',
    cameraError: 'Failed to start camera. Please try again.',
    cameraTimeout: 'Camera session timed out. Please restart the camera.',

    // ValidationInfo.js
    validationTitle: 'Validation Information',
    valid: 'Valid',
    invalid: 'Invalid',
    expired: 'Expired',
    notValidYet: 'Not valid yet',
    signatureValid: 'Signature Valid',
    signatureInvalid: 'Signature Invalid',
    issuerValid: 'Issuer Valid',
    issuerInvalid: 'Issuer Invalid',
    typeValid: 'Type Valid',
    typeInvalid: 'Type Invalid',
    statusValid: 'Status Valid',
    statusInvalid: 'Status Invalid',
    dateValid: 'Date Valid',
    dateInvalid: 'Date Invalid',

    // PatientSummary.js
    composition: 'Composition',
    patient: 'Patient',
    summaryPreparedBy: 'Summary prepared by',
    ipsSection_11450_4: 'Active Problems',
    ipsSection_11348_0: 'Past Medical History',
    ipsSection_10160_0: 'Medication',
    ipsSection_48765_2: 'Allergies and Intolerances',
    ipsSection_8716_3: 'Vital Signs',
    ipsSection_30954_2: 'Laboratory Results',
    ipsSection_11369_6: 'Immunizations',

    // ImmunizationHistory.js
    immunizationHistory: 'Immunization History',
    date: 'Date',
    vaccine: 'Vaccine',
    lotNumber: 'Lot Number',
    jurisdiction: 'Jurisdiction',
    status: 'Status',
    completed: 'Completed',
    notCompleted: 'Not Completed',
    immunization: 'Immunizations',

    // TCPFooter.js
    footerText: 'Powered by TCP',

    // File.js
    fileTitle: 'Open file',
    noFileChosen: 'No file chosen',
    fileDescription: 'The viewer can typically read files with a .smart-health-card or .fhir extension.',
    chooseFile: 'Choose File',
    fileError: 'Error reading file. Please try again.',
    invalidFile: 'Invalid file format. Please choose a valid SMART Health Card file.',

    // Scan.js
    scanError: 'Error scanning QR code. Please try again.',
    scanSuccess: 'QR code scanned successfully',
    readCode: 'Read Code',
    scanTitle: 'Scan a Smart Health Card QR Code',
    // Buttons
    saveToPDF: 'Save to PDF',
    saveToFHIR: 'Save to FHIR',
    source: 'Source',
    takePhotoText: 'Scan',
    openFileText: 'Open file',
    typeOrPaste: 'Type or paste a code',
    findCode: 'Find a code in patient record',

    // TCPFooter.js
    disclaimer: 'DISCLAIMER: ',
    disclaimerDescription: 'THE COMMONS PROJECT FOUNDATION ("TCP") DOES NOT PROVIDE MEDICAL ADVICE OR ADMINISTER ANY DIAGNOSTIC MEDICAL TESTS, VACCINES OR OTHER HEALTHCARE INTERVENTIONS. TCP MAKES NO ENDORSEMENT OR REPRESENTATION AS TO THE ACCREDITATION, LICENSING OR GOOD-STANDING OF ANY HEALTHCARE PROVIDER UNDER APPLICABLE STATE, FEDERAL, NATIONAL OR SUPRANATIONAL LAWS AND REGULATIONS. TCP EXPRESSLY DISCLAIMS ANY AND ALL LIABILITY FOR ANY CONSEQUENTIAL, INDIRECT, INCIDENTAL, SPECIAL OR EXEMPLARY DAMAGES, INCLUDING WITHOUT LIMITATION ANY LOSS OF REVENUES OR PROFITS OR ANY LOSS OF USE OF DATA, ARISING OUT OF OR CONNECTED IN ANY WAY WITH ANY DIAGNOSTIC TESTING, MEDICAL TREATMENT, VACCINATION OR OTHER HEALTHCARE INTERVENTION OR OTHERWISE PROVIDED, SPONSORED, OR PROMOTED BY ANY CTN MEMBER, WHETHER PROVIDED BY THE MEMBER ITSELF OR BY ITS AFFILIATES, REPRESENTATIVES, AGENTS OR SUBCONTRACTORS.',
    linksDislaimer: ' ',
    privacyPolicy: 'Website Privacy Policy',
    termsOfService: 'Terms of Service',

    // About.js
    about: 'About',

    // ValidationInfo.js
    validation1: 'This card is',
    validation2: 'valid',
    validation3: 'and was issued by',
    validation4: 'on',
    invalidValidation: 'invalid',
    noRevocation: 'Because this issuer does not support revocation, details may have changed since that time.',

    // fhirTables.js
    abatementHeader: 'Abatement',
    accessorHeader: 'Assessor',
    activitiesHeader: 'Activities',
    administeredHeader: 'Administered',
    authoredOnHeader: 'Authored On',
    bodySiteHeader: 'Body Site',
    categoryHeader: 'Category',
    criticalityHeader: 'Criticality',
    dateTimeHeader: 'Date/Time',
    daysSupplyHeader: 'Days Supply',
    deliveredHeader: 'Delivered',
    descriptionHeader: 'Description',
    deviceHeader: 'Device',
    dosageHeader: 'Dosage',
    effectiveHeader: 'Effective',
    effectivePeriodDateTimeHeader: 'Effective Period/DateTime',
    flagHeader: 'Flag',
    intentHeader: 'Intent',
    nameHeader: 'Name',
    noteHeader: 'Note',
    onsetHeader: 'Onset',
    organizationHeader: 'Organization',
    outcomeHeader: 'Outcome',
    performedHeader: 'Performed',
    periodStartHeader: 'Period Start',
    policyRuleHeader: 'Policy Rule',
    // In the context of consent, a provision represents an exception: https://build.fhir.org/consent-definitions.html#Consent.provision
    provisionPeriodForConsentHeader: 'Provision Period',
    quantityHeader: 'Quantity',
    reactionHeader: 'Reaction',
    resultHeader: 'Result',
    scopeHeader: 'Scope',
    severityHeader: 'Severity',
    sourceHeader: 'Source',
    statusHeader: 'Status',
    subjectHeader: 'Subject',
    substitutionHeader: 'Substitution',
    summaryHeader: 'Summary',
    testHeader: 'Test',
    // In the context of device use, timing represents how often a device was used: https://build.fhir.org/deviceusage-definitions.html#DeviceUsage.timing_x_
    timingForDeviceUseHeader: 'Timing',

    // documentUtils.js
    documents: 'Documents',
    documentFallbackTitle: 'Document',
    reportFallbackTitle: 'Report',
    documentCategory: 'Document',
    diagnosticReportCategory: 'Diagnostic Report',
    externalDocumentMessage: 'This data could not be displayed because of a technical formatting issue from the EHR, not an issue with your records.',
  },
  fr: {
    // App.js
    aboutTab: 'À propos',
    scanTab: 'Numériser une carte',
    fileTab: 'Ouvrir un fichier',
    photoTab: 'Utiliser votre caméra',
    searchTab: 'Rechercher un dossier',
    dataTab: 'Détails de la carte',

    // About.js
    aboutTitle: 'Lecteur de carte de santé SMART',
    aboutSubtitle: 'Lit et vérifie les cartes de santé SMART',
    getStarted: 'Débuter',
    scanDescriptionShort: 'Utiliser un lecteur de codes-barres 2D',
    photoDescriptionShort: 'Commencer à numériser en utilisant votre caméra',
    fileDescriptionShort:  "Le lecteur peut généralement lire les fichiers portant l'extension .smart-health-card ou .fhir.",

    aboutContent1: 'Développée et maintenue par',
    aboutContent2: 'The Commons Project',
    aboutContent3: 'cette',
    aboutContent4: 'application à source libre',
    aboutContent5: 'peut être utilisée de manière autonome ou intégrée dans un DSE pour lire les informations contenues dans',
    aboutContent6: 'les liens et les cartes de santé SMART',
    aboutContent7: 'Les types de données pris en charge comprennent actuellement',
    aboutContent8: 'les cartes de vaccination contre la COVID-19',
    aboutContent9: 'les dossiers de vaccination en général',
    aboutContent10: 'les résumés internationaux du dossier médical du patient (International Patient Summary, ou IPS)',
    aboutContent11: "et les cartes d'assurance maladie numériques",

    aboutContributing: "Si vous souhaitez déployer vous-même l'application, contribuer à l'ajout de fonctionnalités ou à la correction de bogues dans le cadre du projet, ou si vous avez d'autres questions, veuillez contacter",
    aboutPrivacy: 'Les informations personnelles relatives à la santé sont traitées exclusivement dans le navigateur et ne sont jamais envoyées aux serveurs hébergeant le lecteur',

    // Photo.js
    captureTitle: "Capturer l'image du code QR de carte santé SMART",
    scanDescription: 'Veuillez placer le code QR dans le cadre. Pour de meilleurs résultats, maintenez-le stable et dans un bon éclairage.',
    cameraPaused: 'Caméra en pause',
    restartCamera: 'Redémarrer la caméra',
    changeCamera: 'Changer de caméra',
    openCamera: 'Ouvrir la caméra',
    cameraAccessDenied: 'Accès à la caméra refusé. Veuillez autoriser l\'accès à la caméra et réessayer.',
    noQrCode: 'Aucun code QR détecté. Veuillez réessayer.',
    invalidQrCode: 'Format de code QR invalide. Veuillez scanner un code QR de carte de santé valide.',
    qrCodeError: 'Erreur lors du traitement du code QR. Veuillez réessayer.',
    cameraError: 'Échec du démarrage de la caméra. Veuillez réessayer.',
    cameraTimeout: 'La session de la caméra est écoulée. Veuillez redémarrer votre caméra.',

    // ValidationInfo.js
    validationTitle: 'Informations de validation',
    valid: 'Valide',
    invalid: 'Invalide',
    expired: 'Expiré',
    notValidYet: 'Pas encore valide',
    signatureValid: 'Signature valide',
    signatureInvalid: 'Signature invalide',
    issuerValid: 'Émetteur valide',
    issuerInvalid: 'Émetteur invalide',
    typeValid: 'Type valide',
    typeInvalid: 'Type invalide',
    statusValid: 'Statut valide',
    statusInvalid: 'Statut invalide',
    dateValid: 'Date valide',
    dateInvalid: 'Date invalide',
    invalidValidation: 'invalide',

    // PatientSummary.js
    composition: 'Composition',
    patient: 'Patient',
    summaryPreparedBy: 'Résumé préparé par',
    ipsSection_11450_4: 'Problèmes actifs',
    ipsSection_11348_0: 'Antécédents médicaux',
    ipsSection_10160_0: 'Médicaments',
    ipsSection_48765_2: 'Allergies et intolérances',
    ipsSection_8716_3: 'Signes vitaux',
    ipsSection_30954_2: 'Résultats de laboratoire',
    ipsSection_11369_6: 'Vaccins',

    // ImmunizationHistory.js
    immunizationHistory: 'Historique de vaccination',
    date: 'Date',
    vaccine: 'Vaccin',
    lotNumber: 'Numéro de lot',
    jurisdiction: 'Juridiction',
    status: 'Statut',
    completed: 'Complété',
    notCompleted: 'Non complété',
    immunization: 'Vaccins',

    // TCPFooter.js
    footerText: 'Propulsé par TCP',

    // File.js
    fileTitle: 'Ouvrir un fichier',
    noFileChosen: 'Aucun fichier sélectionné',
    fileDescription: "Le lecteur peut généralement lire les fichiers portant l'extension .smart-health-card ou .fhir.",
    chooseFile: 'Choisir un fichier',
    fileError: 'Erreur lors de la lecture du fichier. Veuillez réessayer.',
    invalidFile: 'Format de fichier invalide. Veuillez choisir un fichier de carte de santé SMART valide.',

    // Scan.js
    scanError: 'Erreur lors du scan du code QR. Veuillez réessayer.',
    scanSuccess: 'Code QR scanné avec succès',
    readCode: 'Lire le code',
    scanTitle: 'Numériser un code QR de santé Smart',

    // Buttons
    saveToPDF: 'Sauvegarder au Format PDF',
    saveToFHIR: 'Sauvegarder au Format FHIR',
    source: 'Source',
    startScanningText: 'Commencer à numériser',
    takePhotoText: 'Numériser',
    openFileText: 'Ouvrir un fichier',
    typeOrPaste: 'Saisir ou coller un code',
    findCode: 'Rechercher un code dans le dossier patient',

    // TCPFooter.js
    disclaimer: 'CLAUSE DE NON-RESPONSABILITÉ : ',
    disclaimerDescription: "LA FONDATION COMMONS PROJECT (« TCP ») NE FOURNIT PAS DE CONSEILS MÉDICAUX ET N'ADMINISTRE PAS DE TESTS MÉDICAUX DIAGNOSTIQUES, DE VACCINS OU D'AUTRES INTERVENTIONS DE SANTÉ. LA TCP NE DONNE AUCUNE GARANTIE NI NE FAIT AUCUNE DÉCLARATION QUANT À L'ACCRÉDITATION, L'AUTORISATION D'EXERCER OU LA BONNE RÉPUTATION D'UN PRESTATAIRE DE SOINS DE SANTÉ EN VERTU DES LOIS ET RÉGLEMENTATIONS ÉTATIQUES, FÉDÉRALES, NATIONALES OU SUPRANATIONALES EN VIGUEUR. LE TCP DÉCLINE EXPRESSÉMENT TOUTE RESPONSABILITÉ EN CAS DE DOMMAGES CONSÉCUTIFS, INDIRECTS, ACCESSOIRES, SPÉCIAUX OU EXEMPLAIRES, Y COMPRIS, MAIS SANS S'Y LIMITER, TOUTE PERTE DE REVENUS OU DE BÉNÉFICES OU TOUTE PERTE D'UTILISATION DE DONNÉES, DÉCOULANT DE OU LIÉS DE QUELQUE MANIÈRE QUE CE SOIT À TOUT TEST DE DIAGNOSTIC, TRAITEMENT MÉDICAL, VACCINATION OU AUTRE INTERVENTION DE SOINS DE SANTÉ OU AUTREMENT FOURNI, PARRAINÉ OU PROMU PAR UN MEMBRE DU CTN, QU'IL SOIT FOURNI PAR LE MEMBRE LUI-MÊME OU PAR SES AFFILIÉS, SES REPRÉSENTANTS, SES AGENTS OU SES SOUS-TRAITANTS.",
    privacyPolicy: 'Politique sur la vie privée du site internet',
    termsOfService: 'Termes et conditions',
    linksDislaimer: '*Tous les liens sont disponibles en anglais seulement ',

    // About.js
    about: 'À propos',

    //Validation.js
    validation1: 'Cette carte est',
    validation2: 'valide',
    validation3: 'et a été émise par le',
    validation4: 'le',
    noRevocation: "Puisque cet émetteur n'effectue pas de révocation, certains details pourraient avoir changé depuis cette date.",

    // fhirTables.js
    abatementHeader: 'Apaisement',
    accessorHeader: 'Évaluateur',
    activitiesHeader: 'Activités',
    administeredHeader: 'Administré',
    authoredOnHeader: 'Rédigé',
    bodySiteHeader: 'Site corporel',
    categoryHeader: 'Catégorie',
    criticalityHeader: 'Criticité',
    dateTimeHeader: 'Date / heure',
    daysSupplyHeader: "Jours d'approvisionnement",
    deliveredHeader: 'Livré',
    descriptionHeader: 'Description',
    deviceHeader: 'Appareil',
    dosageHeader: 'Posologie',
    effectiveHeader: 'Effectif',
    effectivePeriodDateTimeHeader: 'Période de validité / Date et heure',
    flagHeader: 'Indicateur',
    intentHeader: 'Intention',
    nameHeader: 'Nom',
    noteHeader: 'Note',
    onsetHeader: 'Début',
    organizationHeader: 'Organisation',
    outcomeHeader: 'Résultat',
    performedHeader: 'Effectué',
    periodStartHeader: 'Début de la période',
    policyRuleHeader: 'Règle de politique',
    // In the context of consent, a provision represents an exception: https://build.fhir.org/consent-definitions.html#Consent.provision
    provisionPeriodForConsentHeader: "Période d'exception",
    quantityHeader: 'Quantité',
    reactionHeader: 'Réaction',
    resultHeader: 'Résultat',
    scopeHeader: 'Cadre',
    severityHeader: 'Sévérité',
    sourceHeader: 'Source',
    statusHeader: 'Statut',
    subjectHeader: 'Sujet',
    substitutionHeader: 'Substitution',
    summaryHeader: 'Résumé',
    testHeader: 'Test',
    // In the context of device use, timing represents how often a device was used: https://build.fhir.org/deviceusage-definitions.html#DeviceUsage.timing_x_
    timingForDeviceUseHeader: 'Fréquence',

    // documentUtils.js
    documents: 'Documents NEED TRANSLATION',
    documentFallbackTitle: 'Document NEED TRANSLATION',
    reportFallbackTitle: 'Report NEED TRANSLATION',
    documentCategory: 'Document NEED TRANSLATION',
    diagnosticReportCategory: 'Diagnostic Report NEED TRANSLATION',
    externalDocumentMessage: 'This data could not be displayed because of a technical formatting issue from the EHR, not an issue with your records. NEED TRANSLATION',
  }
};
